let baseURL

if(process.env.NODE_ENV === 'development'){
  baseURL = '/api/'
} else if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_CURRENTMODE === 'test'){
  baseURL = '/api/'
} else if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_CURRENTMODE === 'production') {
  // baseURL = '/mini/'
  baseURL = '/api/'
}

export default {
  baseURL: baseURL,
  timeout: 60000,
  ver: '3.2.1',
  src: '5'
}
